import React from 'react';

const Logo = (): React.ReactElement => {
  return (
    <img
      src="/images/nurtura-logo.png"
      alt="Nurtura"
      style={{ width: '100%', height: 'auto', display: 'block' }}
    />
  );
};

export default Logo;
